export const chatgptModels = [
    // { label: 'gpt-4', value: 'gpt-4' }, // hidden due to non-availability for file search
    { label: 'gpt-4o', value: 'gpt-4o' },
    { label: 'gpt-4o-mini', value: 'gpt-4o-mini' },
    { label: 'o1-mini', value: 'o1-mini' },
    { label: 'o1-preview', value: 'o1-preview' },
    { label: 'gpt-4-turbo-preview', value: 'gpt-4-turbo-preview' },
  ];
  
